import React from "react";
import "../Styles/About.css";


const About = () => {
  return (

    <>
       <div className="about-image">
        <img src="./corporate/overview.png " alt="" />
      </div>
    <section className="about-page">
      <h1 className="about-title">About Us</h1>

      <div className="about-text">
        <p>
                Established in 1969 as a partnership firm in the electrical trading sector, Swastika
                Infra Limited has grown into a leading Power Distribution EPC infrastructure
                company in India. The company entered the Power EPC domain in 2011,
                transitioning into large-scale power infrastructure development, and further
                strengthened its corporate foundation by converting into a company in 2019.
        </p>
        <p>
                With over 15 years of experience in Power EPC, we deliver end-to-end turnkey
                solutions covering engineering, design, supply, installation, testing, and
                commissioning of power projects. Our strong execution capabilities have enabled
                us to successfully deliver high-value projects for state electricity distribution
                companies (DISCOMs), contributing to India’s expanding power infrastructure.

        </p>
        <p>
                Our expertise includes underground and overhead cabling, grid and distribution
                substations, rural electrification, smart grid and smart city infrastructure, street
                lighting, and power evacuation systems. We are currently executing and have
                completed projects for leading utilities and government agencies such as
                RRVPNL, AVVNL, RSDCL, WBSEDCL, MGVCL, GED, HPSEBL, UHBVN, UPCL,
                APDCL, JDA and JVVNL. Majority of our projects are funded by the World Bank
                or supported by Central Government institutions including Power Finance
                Corporation (PFC) and REC Limited, reflecting our adherence to global
                standards.

        </p>
        <p>
                Driven by a strong workforce of over 150 professionals, including 100 skilled
                engineers, we continue to expand our scale and capabilities. In 2025, the
                company achieved a significant milestone by securing its single largest order
                valuing Rs. 340 Crores in distribution sector at Sikar, Rajasthan & also entered
                into transmission sector and secured orders valuing Rs. 300 Crores. At Swastika
                Infra Limited, we remain committed to delivering reliable, efficient, and
                sustainable power infrastructure solutions, shaping a power-secure future for
                India.

        </p>

      </div>

     

    </section>


    </>
  );
};

export default About;
